export default __webpack_public_path__ + "static/media/flag-en-USA.c1aa3076.png";